
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kendall",
      function () {
        return require("private-next-pages/kendall/index.tsx");
      }
    ]);
  